import React from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { AppText } from "@/components/AppText";

const EmptyState = () => (
  <View style={styles.emptyState}>
    <AppText style={styles.emptyStateTitle}>No offers available</AppText>
    <AppText style={styles.emptyStateText}>
      Check back later for new earning opportunities
    </AppText>
  </View>
);

const styles = StyleSheet.create({
  emptyState: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
    paddingVertical: 64,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: "#1F2937",
    marginBottom: 8,
    textAlign: "center",
  },
  emptyStateText: {
    fontSize: 16,
    color: "#6B7280",
    textAlign: "center",
    lineHeight: 24,
  },
});

export default EmptyState;
